var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.alert.message)?_c('div',{class:`c-alert c-alert--${_vm.alert.type}`},[_vm._v(_vm._s(_vm.alert.message))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }